<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte";
  import { textHTML } from "../stores/textHTML";
  import { navigate } from "svelte-routing";
  import Navbar from "../components/Navbar.svelte";
  import CardContent from "../components/CardContent.svelte";
  import { user } from "../stores/user";
  import getFecha from "../services/fecha";
  import TipTapV2 from "../components/notificacion/TipTapV2.svelte";
  import Spinner from "../components/Spinner.svelte";
  import Alert from "../components/Alert.svelte";
  import { BASE_URL } from "../stores/BASE_URL";

  let clientes = [];
  let notificaciones = [];

  let estado = true;

  let content = "";
  let isLoading = false;
  let isSaving = false;

  let notificacion = {
    titulo: "",
    id_cliente: "0",
    vencimiento: getFecha(),
    mensaje: "",
    tipo: "descuento",
    inicio_servicio: "0",
  };

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  };

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`);
    const resp = await response.json();
    clientes = resp.data;
  };

  const getNotificaciones = async () => {
    isLoading = true;
    let fecha_estado = "activos";
    if (!estado) fecha_estado = "vencidos";
    const response = await apiFetch(`${BASE_URL}notificacion.php?action=getNotificaciones&estado=${fecha_estado}`);
    const resp = await response.json();
    notificaciones = resp.data;
    isLoading = false;
  };

  const setIncioServicio = async () => {
    if (notificacion.id_cliente == "TODOS-01") {
      notificacion.inicio_servicio = 1;
    } else if (notificacion.id_cliente == "TODOS-16") {
      notificacion.inicio_servicio = 16;
    } else {
      notificacion.inicio_servicio = 0;
    }
  };

  const guardar = async () => {
    isSaving = true;
    notificacion.mensaje = $textHTML;
    console.log(notificacion);
    limpiar();

    const response = await apiFetch(`${BASE_URL}notificacion.php`, {
      method: "POST",
      body: JSON.stringify(notificacion),
    });
    const resp = await response.json();
    if (resp.status == "success") {
      alert.show = true;
      alert.message = "Notificación registrada";
      alert.status = "success";
    } else {
      alert.show = true;
      alert.message = "Error al registrar la notificación";
      alert.status = "danger";
    }

    isSaving = false;
    getNotificaciones();
  };

  const deleteNotificacion = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("action", "deleteNotificacion");

    const response = await apiFetch(`${BASE_URL}notificacion.php`, {
      method: "POST",
      body: formData,
    });

    const resp = await response.json();
    getNotificaciones();
  };

  const limpiar = () => {
    // notificacion = {
    //   titulo: "",
    //   id_cliente: "0",
    //   vencimiento: getFecha(),
    //   mensaje: $textHTML,
    // }
  };

  getClientes();
  getNotificaciones();

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }
  });
</script>

{#if $user}
  <Navbar />

  <div class="container-fluid py-3">
    <CardContent title="Notificaciones">
      <div class="row g-2">
        <div class="col-12 col-md-6">
          <input type="text" class="form-control mb-2" placeholder="Título" bind:value={notificacion.titulo} />
          <TipTapV2 {content} />
        </div>
        <div class="col-12 col-md-6">
          <div class="mb-3 row">
            <label for="cliente" class="col-sm-2 col-form-label"> Cliente </label>
            <div class="col-sm-4">
              <select class="form-select" id="cliente" bind:value={notificacion.id_cliente} on:change={setIncioServicio}>
                <option value="0">TODOS</option>
                <option value="TODOS-01">TODOS (01)</option>
                <option value="TODOS-16">TODOS (16)</option>
                {#each clientes as cliente}
                  <option value={cliente.id}>{cliente.razon_social}</option>
                {/each}
              </select>
            </div>
            <label for="cliente" class="col-sm-2 col-form-label"> Tipo </label>
            <div class="col-sm-4">
              <select class="form-select" id="tipo" bind:value={notificacion.tipo}>
                <option value="descuento">DESCUENTO</option>
                <option value="mensaje">MENSAJE</option>
              </select>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="vencimiento" class="col-sm-2 col-form-label"> Vencimiento </label>
            <div class="col-sm-10">
              <input type="date" id="vencimiento" class="form-control" bind:value={notificacion.vencimiento} />
            </div>
          </div>
          <div class="mb-3 text-end">
            {#if isSaving}
              <button class="btn btn-primary" disabled>Guardando...</button>
            {:else}
              <button class="btn btn-primary" on:click={guardar}>Guardar</button>
            {/if}
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="estado" bind:checked={estado} on:change={getNotificaciones} />
          <label class="form-check-label" for="estado">Estado</label>
        </div>

        {#if alert.show}
          <Alert message={alert.message} status={alert.status} time={alert.time} />
        {/if}

        <div class="table-responsive mt-3">
          <table class="table table-sm table-striped table-bordered small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th>Cliente</th>
                <th>Titulo</th>
                <th>Mensaje</th>
                <th>Tipo</th>
                <th>Inicio del servicio</th>
                <th>Vencimiento</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="7">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#each notificaciones as n}
                  <tr>
                    <td>{n.cliente}</td>
                    <td>{n.titulo}</td>
                    <td>
                      {@html n.mensaje +
                        ` <style>
                            p,li {
                              margin-bottom:5px; /* Ajusta este valor según tus necesidades */
                            }
                          </style>`}
                    </td>
                    <td>{n.tipo}</td>
                    <td>
                      {#if n.inicio_servicio == 0}
                        TODOS
                      {:else}
                        {n.inicio_servicio}
                      {/if}
                    </td>
                    <td>{n.vencimiento}</td>
                    <td>
                      <button class="btn btn-danger btn-sm" on:click={() => deleteNotificacion(n.id)}>
                        <i class="bi bi-trash" />
                      </button>
                    </td>
                  </tr>
                {:else}
                  <tr>
                    <td colspan="7" class="text-center text-secondary"> · · · No se encontraron resultados · · · </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        </div>
      </div></CardContent
    >
  </div>
{/if}
